module.exports = {
	"articleTitle1": "Renovated Alice Lloyd to open in middle of August",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "Alice Lloyd Hall",
	"bathroomrating": [
		{
			"rating": 4,
			"bathroom": "All floors"
		}
	],
	"articleLink2": "https://www.michigandaily.com/content/2008-11-26/about-campus-lloyd-island",
	"articleSnippet1": "Apr 16, 2012 ... After about a year of construction and planning that included student input, Alice \nLloyd Residence Hall will be completed by mid-August as ...",
	"articleSnippet2": "Nov 25, 2008 ... The Lloyd Hall Scholars Program, a living-learning community for art ... \"They \nused to call (Alice Lloyd) 'Lloyd Island' cause there's a lot of kids ...",
	"articleLink1": "https://www.michigandaily.com/news/housing-preview-alice-lloyd-hall-rennovations",
	"articleTitle2": "About Campus: The secret of Lloyd island",
	"address": "100 Observatory St, Ann Arbor, MI 48109",
	"images": [],
	"position": {
		"lat": 42.28127,
		"lng": -83.731815
	},
	"tips": [
		{
			"text": "The basement of Alice Lloyd is really cool. There are music rooms with pianos and a drum set, a nice sized TV for a movie, and a ping pong table.",
			"person": "Erik Forkin"
		}
	],
	"totalMisc": 1,
	"categories": {
		"dorm": 1,
		"misc": 1,
		"location": 1,
		"studyspot": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/alicelloyd.json
// module id = 804
// module chunks = 0